module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/plan_included_photo-72bcdadef9ad29d3aed86315cff297f4.png";